var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFtt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.999 4.002c-6.696-.003-13.39-.003-20.084 0-.002 2.163-.002 4.326 0 6.49 6.694.002 13.389.002 20.083 0l-.001-6.49zM8.487 12.933c-2.16-.01-4.32-.01-6.48 0a624.94 624.94 0 0 0 0 6.48c2.16.011 4.32.011 6.48 0 .011-2.16.011-4.32 0-6.48zm1.433 0c4.832-.01 9.663-.01 14.494 0 .01 2.16.01 4.32 0 6.48-4.831.01-9.662.01-14.493 0-.01-2.16-.01-4.32 0-6.48zm6.474 8.934a297.87 297.87 0 0 0-6.467 0c-.022 2.156-.021 4.312.001 6.466 2.155.022 4.31.022 6.467.001.021-2.156.021-4.312-.001-6.467z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtt);
export default __webpack_public_path__ + "static/media/FTT.374bac96d345107dc92f51b226a1ca4c.svg";
export { ForwardRef as ReactComponent };